import { SiteSettings } from 'lib/page-props-factory/plugins/site-settings';
import { Data } from '@generated/Foundation.GMI.model';
import { getEnumValues } from 'lib/utils/sitecore/enum';
import { KitchenTip } from 'lib/services/models/content-response';

/**
 * Utility to get excluded recipe tip categories from both hardcoded and Sitecore settings.
 * @param recipeTipExcludeCategories - Hardcoded categories to exclude (from RecipeDetail.tsx)
 * @param siteSettings - Sitecore site settings object
 * @returns Array of excluded category IDs
 */

export function getExcludedRecipeTipCategories(
  siteSettings:
    | (SiteSettings & {
        recipeDetailSiteSettings?: Data.Settings.RecipeDetailSiteSettings;
      })
    | null
): string[] {
  const recipeTipExcludeCategoriesHC = ['Kitchen Tested', 'Templates and Diagrams', 'Rich Snippet'];
  const { recipeDetailSiteSettings } = siteSettings || {};
  const sitecoreExcluded = getEnumValues(recipeDetailSiteSettings?.fields?.hideRdpRecipeTips);
  return Array.from(
    new Set(
      [...recipeTipExcludeCategoriesHC, ...sitecoreExcluded].filter(
        (cat): cat is string => typeof cat === 'string' && !!cat
      )
    )
  );
}

/**
 * Filters recipe tips based on excluded categories.
 * @param tips - Array of recipe tips
 * @param excludedCategories - Array of excluded category IDs
 * @returns Filtered tips
 */
export function filterRecipeTipsByExcludedCategories(
  tips: KitchenTip[],
  siteSettings:
    | (SiteSettings & {
        recipeDetailSiteSettings?: Data.Settings.RecipeDetailSiteSettings;
      })
    | null
): KitchenTip[] {
  const excludedCategories = getExcludedRecipeTipCategories(siteSettings);
  return tips.filter((tip) => tip.Category && !excludedCategories.includes(tip.Category ?? ''));
}
